﻿import Vue from 'vue';
import axios from 'axios';

Vue.config.devtools = true;

export default class CareFinder {
    constructor(_elm) {
        const careFinder = new Vue({
            el: '#careFinder',
            data() {
                return {
                    pageId: 0,
                    dataFetched: false,
                    data: null,
                    stepChoices: [],
                    takenSteps: [],
                }
            },
            computed: {
                currentOptions() {
                    if (!this.stepChoices.length) {
                        return this.data.Steps;
                    }
                    else {
                        let options = this.deepCopy(this.data.Steps);
                        this.stepChoices.forEach(choice => {
                            if (options[choice].Steps && options[choice].Steps.length) {
                                options = this.deepCopy(options[choice].Steps);
                            }
                            else if (options[choice].Pages && options[choice].Pages.length) {
                                options = this.deepCopy(options[choice].Pages);
                            }
                        })
                        return options;
                    }
                },
                currentStep() {
                    return this.takenSteps.at(-1);
                },
            },
            methods: {
                fetchAPIData() {
                    axios.get('/umbraco/api/Carefinderapi/getcarefinder?carefinderpageid=' + this.pageId)
                        .then(response => {
                            this.dataFetched = true;
                            this.data = this.deepCopy(response.data);
                            this.takenSteps.push(this.deepCopy(this.data));
                        })
                        .catch(error => {
                            console.log(error);
                        });
                },
                setStepChoiceForward(i, option) {
                    if (option.Url) {
                        window.location.href = option.Url;
                    }
                    else {
                        this.stepChoices.push(i);
                        this.takenSteps.push(this.deepCopy(option));
                    }
                },
                setStepChoiceBack(i) {
                    this.stepChoices = this.deepCopy(this.stepChoices.slice(0, i));
                    this.takenSteps = this.deepCopy(this.takenSteps.slice(0, i + 1));
                },
                deepCopy(inObject) {
                    if (typeof inObject !== "object" || inObject === null) {
                        return inObject;
                    }

                    let outObject = Array.isArray(inObject) ? [] : {}

                    for (let key in inObject) {
                        let value = inObject[key];
                        outObject[key] = this.deepCopy(value);
                    }

                    return outObject;
                }
            },
            mounted() {
                if (parseInt(this.$el.getAttribute('data-pageId'))) this.pageId = parseInt(this.$el.getAttribute('data-pageId'));
                if (this.pageId) this.fetchAPIData();
            }
        })
    }
}
